module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 19.333l6-6 6 6h-3v5h-6v-5h-3zm0-9h12v2H10v-2z\"></path></svg>"